import { Center } from '@chakra-ui/react'
import React from 'react'
import { SignInContent } from '../Auth/SignInContent'
import { FloatingContainer } from '../Containers/FloatingContainer'
import { Header } from '../Header'

export const SignInToView: React.FC<{ message: string }> = ({ message }) => (
  <Center flexFlow="column" w="100%">
    <FloatingContainer w={['100%', '100%', '400px']} py={0} px={0}>
      <Header p={3} px={4} textAlign={['center', 'center', 'left']}>
        {message}
      </Header>
    </FloatingContainer>
    <FloatingContainer w={['100%', '100%', '400px']} mt={4} py={0} px={0}>
      <SignInContent />
    </FloatingContainer>
  </Center>
)
